export default "__VITE_ASSET__eXKIAkmn__"